export default "__VITE_ASSET__CSK5eSX0__"